import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { useAuth } from "../context/auth";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { currencyFormat, getFinalPricewithSymbol, getPrice, getPriceSymbole } from "../Helper";
import { useWishlist } from "../context/WishlistContext";
import PriceHtml from "./PriceHtml";
export default function Wishlist() {
  const [auth, setAuth] = useAuth();
  const [userId, setUserId] = useState(auth?.user?.id);
  const [products, setProducts] = useState([]);
  const [resMsg, setResMsg] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {wishlist, removeFromWishlist } = useWishlist();
  const symbol = getPriceSymbole();
  
  const getProduct = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/wish-list?customer_id=${userId}`
      );
      //console.log(data)
      setProducts(data);
      setLoading(false);
      setResMsg({});
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleRemove = async (e, p_id) => {
    e.preventDefault();
    setResMsg({});
    try {
      setLoading(true);

      if (!auth.user) {
        setLoading(false);
        navigate("/loginsignup");
        return;
      }
      const data = await removeFromWishlist(userId,p_id);
     // getProduct(); // Refresh product list
      setLoading(false);
      setResMsg({
        cls: "alert alert-success text-center",
        msg: data?.message,
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
      setResMsg({
        cls: "alert alert-danger text-center",
        msg: "Failed to remove. Please try again.",
      });
    }
  };

  useEffect(() => {
    getProduct();
    //eslint-disable-next-line
  }, []);
  return (
    <Layout title="My Wishlist | Chaashni by Maansi & Ketan">
      {/*JSON.stringify(auth,null,4) */}
      <div
        className={`site-content-wrap my-account ${loading ? "loading" : ""}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="sustom-heading-h1">
                My <span> Wishlist</span>
              </h1>
              <div className="content-box">
                <div className="wishlist-table table-responsive">
                  {resMsg?.msg ? (
                    <div className={`${resMsg.cls}`}>{resMsg.msg}</div>
                  ) : (
                    ""
                  )}
                  <table className="shop_table cart wishlist_table custom-table">
                    <thead>
                      <tr>
                        <th className="pro-thumbnail">Image</th>
                        <th className="pro-title">Product Name</th>
                        <th className="pro-price">Unit Price</th>
                        <th className="add-to-cart">View Product</th>
                        <th className="pro-remove">Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {wishlist?.length > 0 ? (
                        <>
                          {wishlist?.map((item, i) => (
                            <tr key={i}>
                              <td className="product-thumbnail">
                                <Link to={`/product/${item.product.slug}`}>
                                  <img
                                    className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                    src={`${process.env.REACT_APP_IMAGE_URL}/product/thumbnail/${item.product.thumbnail}`}
                                    alt={item.product.name}
                                    title={item.product.name}
                                  />
                                </Link>
                              </td>
                              <td className="product-name"><Link to={`/product/${item.product.slug}`}>{item.product.name}</Link></td>
                              <td className="product-price">
                                <ins>
                                  <span className="price-amount">
                                    {currencyFormat(
                                      symbol,
                                      getPrice(getFinalPricewithSymbol(item?.product?.discount, item.product.discount_type, item.product.unit_price))
                                    )}
                                    
                                  </span>
                                </ins>                                
                              </td>
                              <td className="product-name"><Link className="wishlist-add-to-cart"  to={`/product/${item.product.slug}`}>View Product</Link></td>
                              <td className="product-remove">
                                <Link
                                  to="/"
                                  onClick={(e) => {
                                   handleRemove(e, item.product_id);
                                   //e.preventDefault();
                                   //removeFromWishlist(userId,item.product_id);
                                  }}
                                  className="remove remove_from_wishlist"
                                  title="Remove this product"
                                >
                                  <i className="fa-regular fa-trash-can"></i>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td className="product-remove" colSpan={5}>
                              No records found
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
